import React, { useMemo } from "react";
import { formatMoney } from "../../../../../features/utils/formatMoney";

function PricingBreakdown({ data }) {
  const travellerLib = {
    ADT: "Adult",
    CHD: "Child",
    CNN: "Child",
    INF: "Infant",
    INS: "Infant",
  };

  const passengers = data?.flightBooking?.travelers || [];
  const raw = data?.priceBreakdown || [];

  const perPassenger = useMemo(() => {
    return raw.map((it) => {
      const p = passengers.find((pp) => pp?.id === it?.passengerId) || {};
      const travellerType =
        it?.travellerType || travellerLib[p?.travelerType] || "Adult";
      const name =
        it?.passenger ||
        [p?.firstName, p?.middleName, p?.lastName].filter(Boolean).join(" ") ||
        travellerType;

      const subtotal =
        (it.changePrice || 0) +
        (it.ticketDifference || 0) +
        (it.penaltyFee || 0) +
        (it.changeFee || 0);

      return { ...it, travellerType, passenger: name, subtotal };
    });
  }, [raw, passengers]);
  return (
    <div className="w-full flex flex-col">
      {perPassenger.map((row) => (
        <div key={row._id || row.passengerId} className="mb-4 last:mb-0">
          <div className="flex justify-between items-center mb-2">
            <span className="font-medium">1 x {row.travellerType}</span>
            <span className="font-semibold text-gray-900">
              {formatMoney(row.subtotal)}
            </span>
          </div>

          <div className="pl-4 space-y-1">
            <div className="flex justify-between">
              <span className="text-gray-500">
                Change fee per {row.travellerType.toLowerCase()}
              </span>
              <span className="text-gray-700">
                {formatMoney(row.changePrice || 0)}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">
                Ticket difference per {row.travellerType.toLowerCase()}
              </span>
              <span className="text-gray-700">
                {formatMoney(row.ticketDifference || 0)}
              </span>
            </div>

            {(row.penaltyFee || 0) > 0 && (
              <div className="flex justify-between">
                <span className="text-gray-500">
                  Penalty fee per {row.travellerType.toLowerCase()}
                </span>
                <span className="text-gray-700">
                  {formatMoney(row.penaltyFee || 0)}
                </span>
              </div>
            )}
          </div>
        </div>
      ))}

      {/* Service fee from top-level data */}
      <div className="flex justify-between items-center mt-4 mb-4">
        <span className="font-medium">
          {data?.flightBooking?.travelers?.length} x Service fee
        </span>
        <span className="font-semibold text-gray-900">
          {formatMoney(data?.fee || 0)}
        </span>
      </div>

      <hr className="border-gray-300 mb-3" />

      {/* Totals from top-level data */}
      <div className="flex justify-between items-center mb-1">
        <span className="font-semibold text-gray-900">Total</span>
        <span className="font-semibold text-gray-900">
          {formatMoney(data?.fee || 0)}
        </span>
      </div>

      <div className="text-right mt-1 text-primary1 font-semibold text-lg">
        {formatMoney(data?.fee || 0)}
      </div>
    </div>
  );
}

export default PricingBreakdown;
